import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";
import {TomInput} from "tom-select/dist/cjs/types/core";
import {api} from "../services/api";

export default class extends Controller {
  static values = { createPath: String };
  declare readonly createPathValue?: string;
  declare readonly hasCreatePathValue: boolean;
  select: TomSelect;

  connect() {
    this.select = new TomSelect(this.element as TomInput, {
      openOnFocus: true,
      valueField: 'id',
      labelField: 'name',
      searchField: ['name'],
      plugins: ['clear_button'],
      create: (val, callback) => {
        if (!val?.length || !this.hasCreatePathValue) return false;
        (async () => {
          try {
            const { data } = await api.postDealershipType({ dealership_type: { name: val } });
            callback(data);
          }
          catch (e) {
            const container = this.element.closest('.input.group.tom_select'),
                errorEl = container.querySelector('span.error');
            const { response } = e,
                { data } = response ?? {},
                { error } = data ?? {},
                errorMsg = !!error?.length ? error : 'Invalid input';
            if (!!errorEl) {
              errorEl.textContent = errorMsg;
              errorEl.classList.remove('hidden');
            }
            this.select.clear();
            this.select.close();
          }
        })();
      },
    });
  }

  keydown = e => {
    console.log('keydown', e.key);
    if (e.key === 'Enter') {
      e.preventDefault();
      this.select.createItem();
    }
  }
}
